import { createSelector } from 'reselect'
import { startsWith, cloneDeep } from 'lodash';
import { vinWiseOpening } from './model'

export const getIsFetchingVinWiseOpening = (state, props) => state.vinWiseOpening.params.isFetching;
export const getIsVinWiseOpeningFetched = (state, props) => state.vinWiseOpening.params.vinWiseOpeningFetched;
export const getVinWiseOpeningList = (state, prop) => state.vinWiseOpening.byId
export const getIsSearching = (state, props) => state.vinWiseOpening.params.isSearching;
export const getIsSearchFetched = (state, props) => state.vinWiseOpening.params.searchFetched;
export const getSearchResults = (state, prop) => state.vinWiseOpening.searchResults
export const filters = (state, prop) => state.vinWiseOpening.filterResults;
export const getDeleteStatus = (state, prop) => state.vinWiseOpening.deleteStatus
export const getDelFetched = (state, prop) => state.vinWiseOpening.params.isDelFetched
export const getNotification = (state, id) => state.vinWiseOpening.notifications[id]

export const getVinWiseOpening = (state, props) => {
    if (props.match.path === '/vin_wise_opp/create') {
        return vinWiseOpening()
    }
    if (props.match.path === '/vin_wise_opp/edit/:id') {
        let id = props.match.params.id
        let obj = cloneDeep(state.vinWiseOpening.byId[id]);
        return obj
    }
}

export const getVinWiseOpeningParams = (state, props) => {
    const params = {}

    if (startsWith(state.router.location.pathname, '/vin_wise_opp/create')) {
        params.title = state.vinWiseOpening.params.createTitle
        params.submitButtonText = state.vinWiseOpening.params.createSubmitButtonText
    };

    if (startsWith(state.router.location.pathname, '/vin_wise_opp/edit/')) {
        params.title = state.vinWiseOpening.params.editTitle
        params.submitButtonText = state.vinWiseOpening.params.editSubmitButtonText
    };

    return params
}

export const selectVinWiseOpening = createSelector(
    getVinWiseOpeningList,
    vinWiseOpening => {
        const keys = Object.keys(vinWiseOpening)
        const obj = keys.map((key) => { return { key: key, value: key, text: vinWiseOpening[key].name } })
        return obj
    })


export const selectVinWiseOpeningSearched = createSelector(
    getSearchResults,
    vinWiseOpening => {
        const keys = Object.keys(vinWiseOpening)
        const obj = keys.map((key) => { return { key: key, value: key, text: vinWiseOpening[key].name } })
        return obj
    })


export const getFilteredVinWiseOpening = createSelector(
    getVinWiseOpeningList,
    (vinWiseOpening) => {
        let filteredVinWiseOpening = Object.keys(vinWiseOpening).map(function (key) {
            return vinWiseOpening[key];
        })
        return filteredVinWiseOpening
    })